module.exports = __webpack_public_path__ + "img/scenario_09.3119daa8.jpg";